import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHomeAlt,
} from '@fortawesome/free-solid-svg-icons';
import {
  Box, Grid, Typography, Breadcrumbs, Button,
} from '@mui/material';

import { Link } from 'react-router-dom';
import { Form } from '@unform/web';

import { HOME, ASSOCIATES } from 'Shared/Constant/Routes';
import { IAssociateDetailPage } from '../Interface';
import AssociateHeaderPage from './AssociateHeader/index';
import FieldsByGroupCustomPage from 'Shared/Components/Form/FieldsByGroupCustom/index';
import TargetModalPage from './AssociateTargetModal/index';
import { IAssociates } from 'Module/Associates/Interface';
import ModalQuestionYesNoPage from 'Shared/Components/ModalQuestionYesNo/index';
import { IModalQuestionYesNoPage } from 'Shared/Components/ModalQuestionYesNo/Interface';
import TypeAnswerConstant from 'Shared/Constant/TypeAnswer/index';

function AssociateDetailPage(props: IAssociateDetailPage) {
  const formDefault = React.useRef<any>(null);

  const handleOpenModalTarget = () => {
    if (props.toggleShowAssociateTargetModal) {
      props.toggleShowAssociateTargetModal(true);
    }
  }

  const [associateUpdate, setAssociateUpdate] = React.useState<IAssociates>({});
  const [associateIDUpdate, setAssociateIDUpdate] = React.useState<string>('');

  const [fieldActive, setFieldActive] = React.useState<boolean>(false);
  const handleChangeCurrency = (event: any, value: any, maskedValue: any) => {
    //handleChangeCurrency
  };

  const handleChangeSelect = (event: any, field?: string) => {
    switch (field) {
      case 'active':
        setFieldActive(event.value)
        break;
      default:
        break;
    }
  }

  const handleSubmit = (data: any) => {
    const _id = props.item.id ? props.item.id : data.id;
    let _reg: IAssociates = {
      codigo: data.codigo,
      nome: data.nome.toUpperCase(),
      documento: data.documento,
      codigoPrincipal: data.codigoPrincipal,
      email: data.email,
      active: fieldActive,
      userupdate: props.profile.userid,
      ipupdate: props.publicIPInfo,
      deviceupdate: 'Portal',
    }
    setAssociateUpdate(_reg);
    setAssociateIDUpdate(_id);
    if (props.toggleShowModalQuestionYesNoDetail) {
      props.toggleShowModalQuestionYesNoDetail(true);
    }
  }

  React.useEffect(() => {
    setFieldActive(props.item.active ? props.item.active : false);
  }, [props.item, props.dateUpdateInfo])

  const toggleAnswerDetail = (key: string) => {
    switch (key) {
      case TypeAnswerConstant.YES:
      case TypeAnswerConstant.OK:
        props.toggleSetAssociates(associateUpdate, associateIDUpdate);
        break;
      default:
        break;
    }
  }

  const handlerModalQuestion: IModalQuestionYesNoPage = {
    ...props,
    titlePage: 'Confirmação',
    question: 'Deseja alterar o registro?',
    toggleAnswer: toggleAnswerDetail,
    toggleShowModalQuestion: props.toggleShowModalQuestionYesNoDetail
  }

  return (
    <Box id="AssociateDetail" key="AssociateDetail" className="ChildrenRoot">
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography component="div" align="left" sx={{ alignContent: 'center', alignItems: 'center' }}>
            <Box id="BreadcrumbsBox" className="Breadcrumbs">
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to={HOME}>
                  <FontAwesomeIcon icon={faHomeAlt} />
                </Link>
                <Link color="inherit" to={ASSOCIATES}>
                  Associados
                </Link>
              </Breadcrumbs>
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <AssociateHeaderPage {...props} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Form
            ref={formDefault}
            id="myFormDefault"
            name="myFormDefault"
            onSubmit={handleSubmit}
          >
            <Grid container spacing={1}>
              <Grid item xs={6} sm={4} md={3} lg={3} xl={3}>
                {props.isTypeGroupEdit &&
                  <Typography component="div" align="left" sx={{ padding: '0px 5px 5px 0px' }}>
                    <Button
                      variant="contained"
                      color="success"
                      className="ButtonPrimary"
                      type="submit"
                    >
                      <span>Salvar detalhes</span>
                    </Button>
                  </Typography>
                }
              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={3} xl={3}>
                {props.isTypeGroupEdit &&
                  <Typography component="div" align="left" sx={{ padding: '0px 5px 5px 0px' }}>
                    <Button
                      variant="contained"
                      color="success"
                      className="ButtonDanger"
                      type="button"
                      onClick={handleOpenModalTarget}
                    >
                      <span>Cadastrar Metas</span>
                    </Button>
                  </Typography>
                }
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography component="div" align="left">
                  <FieldsByGroupCustomPage
                    expanded={true}
                    title='Informações do Associado'
                    structure={props.structure}
                    fields={props.item}
                    isTypeGroupEdit={props.isTypeGroupEdit ? true : false}
                    dateUpdateInfo={props.dateUpdateInfo}
                    handleChangeCurrency={handleChangeCurrency}
                    handleChange={handleChangeSelect}
                  />
                </Typography>
              </Grid>
            </Grid>
          </Form>
        </Grid>
      </Grid>
      {props.showAssociateTargetModal &&
        <TargetModalPage {...props} />
      }
      {props.showModalQuestionYesNoDetail &&
        <ModalQuestionYesNoPage {...handlerModalQuestion} />
      }
    </Box>
  )
}


export default AssociateDetailPage;
